import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'common/stylus/index.styl';
import ElementUI from 'element-ui';
import VCharts from 'v-charts';
import 'element-ui/lib/theme-chalk/index.css';
import 'common/stylus/iconfont.css';

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VCharts);

export default new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#PC');
